import React from 'react'

import { Button } from 'primereact/button'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Dropdown } from 'primereact/dropdown'

import { formatDate } from '../../js/utils'

import '../../css/lobbyist-table.css'

const StatusFilterTemplate = ({ statusFilter, tableRef, statuses }) => {
  return <Dropdown className={'status-filter-dropdown'} options={statuses} value={statusFilter.value} optionLabel="Description" dataKey="Description" showClear={true}
    onChange={(e) => statusFilter.onChange(e, tableRef, statusFilter.filterName)} />
}

const ModifiedDateTemplate = rowData => {
  return <span>{formatDate(rowData['ModifiedDate'])}</span>
}

const LobbyistTableHeader = ({ tableRef, exportToExcel }) => {
  return <div style={{ textAlign: 'left' }}>
    <Button type="button" icon="pi pi-external-link" iconPos="left" label="Export to Excel" onClick={() => exportToExcel(tableRef)}></Button>
  </div>
}

const LobbyistTable = ({ lobbyists, statuses, isAdmin, goToLobbyist, statusFilter, sort, tableRef, exportToExcel }) => {
  let showStatusColumn = typeof statusFilter !== "undefined"
  let statusFilterTemplate = showStatusColumn && <StatusFilterTemplate statuses={statuses} statusFilter={statusFilter} tableRef={tableRef} />

  let columnDefinitions = [
    { field: 'TradingName', header: 'Trading Name', sortable: true, filter: true, filterMatchMode: 'contains' },
    { field: 'BusinessName', header: 'Business Name', sortable: true, filter: true, filterMatchMode: 'contains' },
    { field: 'Abn', header: 'ABN', sortable: true, filter: true, style: { width: '160px' } },
    { field: 'ModifiedDate', header: 'Last Updated', sortable: true, filter: false, body: ModifiedDateTemplate, style: { width: '130px' } },
  ]
  if (isAdmin && showStatusColumn) {
    columnDefinitions.push({ field: 'StatusDescription', header: 'Status', sortable: true, filter: true, filterElement: statusFilterTemplate })
  }

  let columns = columnDefinitions.map((col, i) => {
    return <Column key={col.field} {...col} /> 
  })

  let header = <LobbyistTableHeader tableRef={tableRef} exportToExcel={exportToExcel} />
  return (
    <DataTable value={lobbyists} header={header} selectionMode="single" 
      sortField={sort.value.sortField} sortOrder={sort.value.sortOrder} onSort={(e) => { sort.onChange(e, sort.sortName) }}
      onSelectionChange={goToLobbyist} className="lobbyist-table" ref={tableRef} responsive={true}>
      {columns}
    </DataTable>
  )
}

export default LobbyistTable;


// WEBPACK FOOTER //
// ./src/components/lobbyist/lobbyist-table.js